module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-wwp-fcfe11850aaa7a00287fbc6f02acda38.svg";